export default "__VITE_ASSET__DTdP$Bvp__"